export const CHANGE_SERVICE_CARD = 'changeSevriceCard'
export const GET_SERVICE_CARD_CONFIG = 'getSevriceCardConfig'
export const SET_EMAIL_SUBJECT = 'setEmailSubject'
export const FRACTIONAL_CPO_SERVICE = "fractionalCPO"
export const STRATEGY_CONSULTING_SERVICE = "strategyService"
export const PRODUCT_COACHING_SERVICE = "productCoachingService"
export const PRODUCT_PROCESS_SERVICE = "productProcessgService"
export const SEND_EMAIL = "sendEmail"
export const GET_EMAIL_SUBJECT = "getEmailSubject"
export const RESET_EMAIL = "resetEmail"